import { EditorState, generateName } from "@common/Common";

export class CostSubtotalEditorViewModel
{
    state: EditorState = EditorState.Closed;

    id: string | null = null;
    name: string | null = null;

    get opened(): boolean { return this.state !== EditorState.Closed; }

    showCreator()
    {
        this.id = null;
        this.name = generateName("Subtotal");

        this.state = EditorState.Creator;
    }

    showEditor(id: string, name: string)
    {
        this.id = id;
        this.name = name;

        this.state = EditorState.Editor;
    }

    close()
    {
        this.state = EditorState.Closed;

        this.id = null;
        this.name = null;
    }
}

export class CreateCostSubtotalEventPayload
{
    name: string;

    constructor(name: string)
    {
        this.name = name;
    }
}

export class RenameCostSubtotalEventPayload
{
    id: string;
    name: string;

    constructor(id: string, name: string)
    {
        this.id = id;
        this.name = name;
    }
}